export enum ItemStatus {
  Draft = 'draft',
  Published = 'published',
  Archived = 'archived'
}
